var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
const SvgTimer = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "vuesax/linear/timer"
  }, /*#__PURE__*/React.createElement("g", {
    id: "timer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M20.3207 2.66699H11.6807C6.66737 2.66699 6.2807 7.17366 8.98737 9.62699L23.014 22.3737C25.7207 24.827 25.334 29.3337 20.3207 29.3337H11.6807C6.66737 29.3337 6.2807 24.827 8.98737 22.3737L23.014 9.62699C25.7207 7.17366 25.334 2.66699 20.3207 2.66699Z",
    stroke: "white",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })))));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgTimer, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/timer.0ff380b5.svg";
export { ForwardRef as ReactComponent };